module.exports = __webpack_public_path__ + "static/media/tn.87ff0467.svg";